import { HighlightType } from '../types/profile';

/**
 * Multipart saves omit a field when there is nothing to append. An empty
 * highlight list must still be sent, or the server leaves the previous
 * highlights in place and the next response puts them back.
 * Files are uploaded only until imagePath exists, so a later delete does not
 * re-upload every photo.
 */
export function appendHighlightsFormFields(
    formData: FormData,
    highlights: HighlightType[] | null | undefined
) {
    const list = highlights ?? [];
    if (list.length === 0) {
        formData.append('highlights', '[]');
        return;
    }

    list.forEach((highlight, index) => {
        formData.append(`highlights[${index}][url]`, highlight.url || '');
        formData.append(`highlights[${index}][description]`, highlight.description || '');
        if (highlight.image?.file && !highlight.imagePath) {
            formData.append(`highlights[${index}][image]`, highlight.image.file);
        }
        formData.append(`highlights[${index}][imagePath]`, highlight.imagePath || '');
        formData.append(`highlights[${index}][mediaUrl]`, highlight.mediaUrl || '');
        formData.append(`highlights[${index}][coverArtUrl]`, highlight.coverArtUrl || '');
        formData.append(`highlights[${index}][typeCd]`, highlight.typeCd || '');
    });
}
